export default __webpack_public_path__ + "static/Sharecare_Logo_Square-48f51d048a3cbb131420ee8ab7c54d9a.png";